import { match } from "ts-pattern";
import { ScheduleV2Compat, type DateTimeRecord, type ScheduleV2 } from "@visioni/schedules";
import type { AlarmSchedule } from "./types";
import { mode } from "../schema/alarm-schedule";

export type { Mode } from "../schema/alarm-schedule";

/** Upgrade a V1 schedule to V2, passing V2 schedules through unchanged. */
const toV2 = (schedule: AlarmSchedule | ScheduleV2): ScheduleV2 =>
  match(schedule)
    .with({ schema_version: "1" }, (s) => ScheduleV2Compat.fromV1(s))
    .with({ schema_version: "2" }, (s) => s)
    .exhaustive();

/** Returns the current {@link Mode} of the schedule at {@link at}. */
export const getMode = (schedule: AlarmSchedule | ScheduleV2, at: DateTimeRecord) => mode(toV2(schedule), at);
